const ListingCardSkeleton: React.FC = () => {
  return (
    <div className="flex-shrink-0 w-full bg-white animate-pulse">
      <div className="relative w-full aspect-[4/3] overflow-hidden bg-gray-200 rounded-2xl">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 bg-[length:200%_100%] animate-shimmer" />
      </div>

      <div className="mt-2 space-y-2">
        <div className="space-y-1.5">
          <div className="h-3.5 bg-gray-200 rounded-md w-full" />
          <div className="h-3.5 bg-gray-200 rounded-md w-2/5" />
        </div>

        <div className="flex items-center justify-between">
          <div className="h-4 bg-gray-200 rounded-md w-32" />
          <div className="flex items-center gap-1">
            <div className="h-4 w-4 bg-gray-200 rounded-full" />
            <div className="h-3 bg-gray-200 rounded w-7" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingCardSkeleton;
